<template>
  <!--加入我们 -->
  <div class="main">
    <mineheader v-if="isAlive" ></mineheader>
    <!-- 主要部分 -->
    <router-view v-if="isAlive" ></router-view>
    <minefooter v-if="isAlive" ></minefooter>
  </div>
</template>

<script>
import Minefooter from "./components/minefooter.vue";
import Mineheader from "./components/mineheader.vue";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isAlive: true,
    };
  },
  methods: {
    reload() {
      this.isAlive = false;
      this.$nextTick(() => {
        this.isAlive = true;
      });
    },
  },
  components: {
    Mineheader,
    Minefooter
  },
  computed: {},
};
</script>
<style scoped>
.main {
  background: white;
}

/* 以下为主页 */
</style>
